import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteFacility                  from "../../../../application/usecase/facility/DeleteFacility";
import Facility                        from "../../../../domain/facility/Facility";

interface Props {
  facility: Facility;
}

const ReservationFacilityDelete: FC<Props> = (props: Props) => {
  const {facility} = props;
  const [open, setOpen] = useState(false);
  const deleteFacility: DeleteFacility = new DeleteFacility(useDispatch());
  return (
    <>
      <Button
        icon
        negative
        labelPosition="left"
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>施設・設備削除の確認</Modal.Header>

        <Modal.Content>
          <Header as="h5" icon="info circle" content={`${ facility.name.value }を削除します。`} dividing color="red"/>
          <Modal.Description>
            <p>
              すでに「{ facility.name.value }」に予約が入っている場合、「{ facility.name.value }」の予約を確認することができなくなります。<br/>
              よろしいですか？
            </p>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
          <Button
            icon
            negative
            labelPosition="left"
            onClick={ () => {
              deleteFacility.execute(facility.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ReservationFacilityDelete;